import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from '../../core/services/modal.service';

@Component({
	selector: 'app-promo-stacks-modal',
	templateUrl: './promo-stacks-modal.component.html',
	styleUrls: ['./promo-stacks-modal.component.scss'],
})
export class PromoStacksModalComponent {
	@Input() modalId;

	@Input() user;

	@Output() closeModal = new EventEmitter();

	constructor(
		private ms: ModalService,
		private router: Router,
	) { }

	promosStacks() {
		if (this.user) {
			this.router.navigate([`/author-dashboard/${this.user.authorLink}/promo-stacks`]).then();
			this.ms.close(this.modalId);
			return;
		}

		this.router.navigate(['/promo-stacks']).then();
		this.ms.close(this.modalId);
	}

	cancel() {
		this.closeModal.emit();
		this.ms.close(this.modalId);
	}
}
